import { get } from 'lodash';

const getComponent = (type, components = [], shortName = false) => {
  const component = components.find(c => get(c, 'types', []).includes(type));

  if (!component) {
    return undefined;
  }

  return shortName ? component.short_name : component.long_name;
};

// Extracts the most relevant address parts of a Google maps GeocoderResult
//
// https://developers.google.com/maps/documentation/javascript/reference/geocoder#GeocoderResult
// https://developers.google.com/maps/documentation/geocoding/intro#Types
export default (result = {}) => {
  const components = get(result, 'address_components', []);
  let streetAddress = getComponent('street_address', components);

  if (!streetAddress) {
    streetAddress = [
      getComponent('street_number', components),
      getComponent('route', components),
    ]
      .filter(Boolean)
      .join(' ');
  }

  return {
    city: getComponent('locality', components),
    country: getComponent('country', components),
    countryCode: getComponent('country', components, true),
    postalCode: getComponent('postal_code', components),
    province: getComponent('administrative_area_level_1', components, true),
    streetAddress,
  };
};



// WEBPACK FOOTER //
// ./src/utils/getAddressComponents.js